export class WebsitePrimaryColor {
    static readonly HR = '#85c226';
    static readonly CV = '#BE2EA4';
    static readonly DOCTOR = '#539B96';
    static readonly CHEFS = '#76AFC1';
    static readonly CUSTOMER = '#85c226';
}